export default function IsAdmin()
{
  return true
}
